module.exports = __webpack_public_path__ + "img/点火线圈.png";